/* -----------------------------------------------------------------------------
 * Wizard SM Getters
 *
 * @description - Getters of Wizard SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

export default {

  /**
   * Get steps list
   * @description Returns array of all step routes objects
   * @param {Object} state - Wizard SM state
   * @returns {Array}
   */
  getStepsList (state) {
    return state.steps
  },

  /**
   * Get steps count
   * @description Returns count of wizard steps
   * @param {Object} getters - Wizard SM getters
   * @returns {Number}
   */
  getStepsCount (_, getters) {
    return getters.getStepsList.length
  },

  /**
   * Get current step index
   * @description Returns index of the current step
   * @param {Object} state - Wizard SM state
   * @returns {Number}
   */
  getCurrentStepIdx (state) {
    return state.stepIdx
  },

  /**
   * Get current step name
   * @description Returns name of the current step
   * @param {Object} state - Wizard SM state
   * @param {Object} getters - Wizard SM getters
   * @returns {String}
   */
  getCurrentStepName (_, getters) {
    return getters.getStepsList.find(s => s.idx === getters.getCurrentStepIdx).name
  },

  /**
   * Get current route name
   * @description Returns name of the current route
   * @param {Object} state - Wizard SM state
   * @returns {String}
   */
  getCurrentRouteName (state) {
    return state.routeName
  },

  /**
   * Is current route
   * @description Returns flag about comparing given & current routes names
   * @param {Object} state - Wizard SM state
   * @param {String} name - Given route name
   * @returns {Boolean}
   */
  isCurrentRoute: (_, getters) => name => name === getters.getCurrentRouteName,

  /**
   * Is wizard mode
   * @description Returns status is current route is step or not
   * @param {Object} state - Wizard SM state
   * @returns {Boolean}
   */
  isWizardMode (state) {
    return state.routeStepIdx > -1
  },

  /**
   * Allow step switch
   * @description Returns step switch locker status (true if allowed)
   * @param {Object} state - Wizard SM state
   * @returns {Boolean}
   */
  allowStepSwitch (state) {
    return !state.lockStepSwitch
  },

  /**
   * Get next step index
   * @description Returns next step index
   * @param {Object} state - Wizard SM state
   * @param {Object} getters - Wizard SM getters
   * @returns {Number}
   */
  getNextStepIdx (_, getters) {
    const current = getters.getCurrentStepIdx
    const next = current + 1
    if (next > getters.getStepsCount - 1) return current
    return next
  },

  /**
   * Get previous step index
   * @description Returns previous step index
   * @param {Object} state - Wizard SM state
   * @param {Object} getters - Wizard SM getters
   * @returns {Number}
   */
  getPrevStepIdx (_, getters) {
    const current = getters.getCurrentStepIdx
    const prev = current - 1
    if (prev < 0) return current
    return prev
  },

  /**
   * Get next step name
   * @description Returns next step name
   * @param {Object} getters - Wizard SM getters
   * @returns {String}
   */
  getNextStepName (_, getters) {
    return getters.getStepsList.find(s => s.idx === getters.getNextStepIdx).name
  },

  /**
   * Get previous step name
   * @description Returns previous step name
   * @param {Object} getters - Wizard SM getters
   * @returns {String}
   */
  getPrevStepName (_, getters) {
    return getters.getStepsList.find(s => s.idx === getters.getPrevStepIdx).name
  },

  /**
   * Get current view vm
   */
  getCurrentViewVm: state => state.view,

  /**
   * Get nav fields
   */
  getNavFields: state => state.navigation,

  // ----------------------------------------------------------- [Robot message]

  /**
   * Get robot message
   */
  getRobotMessage (state) {
    const ctx = state.view
    if (!ctx || !('robotMessage' in ctx)) return '' // fallback
    return ctx.robotMessage
  }

}
